import React, { useState, useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { checkForInternetExplorer11 } from "@utils/compatibility-utils";
import styled from "styled-components";

const query = graphql`
	{
		file(
			relativePath: { regex: "/demographic-data-storymap.(png)|(jpg)$/" }
		) {
			childImageSharp {
				fluid(maxWidth: 500) {
					...GatsbyImageSharpFluid
				}
			}
		}
	}
`;

const Img = props => {
	const imgRef = useRef();

	const renderDefaultImage = () => (
		<img
			{...props}
			style={{ ...props.style }}
			ref={imgRef}
			fluid={null}
			srcSet={props.fluid.srcSet}
		/>
	);

	const renderIE11CompatibleImage = () => (
		<img
			{...props}
			ref={imgRef}
			src={props.fluid.src}
			fluid={null}
			style={{
				...props.style,
				width: null,
			}}
		/>
	);

	const [img, setImg] = useState(renderDefaultImage());

	useEffect(() => {
		if (imgRef.current.complete) {
			props.onLoad("loaded");
		}
	});

	useEffect(() => {
		if (checkForInternetExplorer11()) {
			setImg(renderIE11CompatibleImage());
		}
	}, []);

	return img;
};

const StorymapImageWrapper = styled.div`
	height: 100%;
	max-width: 600px;

	div.image-link-container {
		transition: all 100ms ease-out;
	}

	div.image-link-container:hover,
	div.image-link-container:focus,
	div.image-link-container.has-focus {
		box-shadow: hsla(0, 0%, 0%, 0.28) 5px 6px 13px 0px;
		transform: translate(-2px, -2px);
		a {
			text-decoration-color: #fff;
		}
	}
`;

const DemographicStorymapImage = ({ url, header, onLoad }) => {
	const fluid = useStaticQuery(query).file.childImageSharp.fluid;
	const [hasFocus, setHasFocus] = useState(false);

	return (
		<StorymapImageWrapper>
			<div
				className={`image-link-container rounded overflow-hidden${
					hasFocus ? " has-focus" : ""
				}`}
			>
				<a
					href={url}
					aria-labelledby="demographic-storymap-header"
					onFocus={() => setHasFocus(true)}
					onBlur={() => setHasFocus(false)}
				>
					<div
						className="bg-dark text-light w-100 py-3 text-center h5 m-0"
						id="demographic-storymap-header"
					>
						{header}
					</div>
					<Img
						fluid={fluid}
						onLoad={onLoad}
						style={{
							objectFit: "contain",
							width: "100%",
						}}
						alt="Map of nevada showing current districts"
					/>
				</a>
			</div>
		</StorymapImageWrapper>
	);
};

export default DemographicStorymapImage;
